import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { whatsappUrl } from '../utils/contact';
interface WhatsAppButtonProps {
  message: string;
  children: React.ReactNode;
  variant?: 'solid' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showIcon?: boolean;
}
export function WhatsAppButton({
  message,
  children,
  variant = 'solid',
  size = 'md',
  className = '',
  showIcon = true
}: WhatsAppButtonProps) {
  const sizes: Record<string, string> = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-3 text-sm',
    lg: 'px-7 py-4 text-base'
  };
  const variants: Record<string, string> = {
    solid: 'bg-neon text-ink-950 hover:bg-neon-soft shadow-glow focus-visible:outline-neon',
    outline: 'border border-neon/60 text-neon hover:bg-neon/10 hover:border-neon'
  };
  return <a href={whatsappUrl(message)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-medium transition-[background-color,border-color,color,transform] duration-200 ease-out active:translate-y-px ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-287" data-mp="2zqkek1eaim9e">
      {showIcon ? <MessageCircleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-288" data-mp="ia9hfolexeuy" /> : null}
      {children}
    </a>;
}